import { MyleTableColumn } from "@/Common/Components/Tables/MyleTableColumn";
import { LabActionInboxSortOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { LabsStore } from "@/Labs/Stores/LabsStore";

class LabsActionsInboxViewHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Labs.OnRefreshClickActionInbox, this.OnRefreshClickActionInbox);
        this.RegisterOperation(LocalOperations.Labs.SearchBoxActionInboxTextChanged, this.SearchBoxActionInboxTextChanged);

        this.RegisterOperation(LocalOperations.Misc.Table_ColumnSortClick, this.SetColumnSort);
    }

    public SearchBoxActionInboxTextChanged(request: LocalEvent, store: LabsStore): void {
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("GlobalActionSearchText", request.Get<string>("value"));

        store.LabActions.RefreshActions(store.LabsActionInboxModel.get("CurrentInbox"), store.LabsActionInboxModel.get("GlobalActionSearchText"), store.LabsActionInboxModel.get("SortColumn"), store.LabsActionInboxModel.get("SortColumnDirection"));
    }

    public OnRefreshClickActionInbox(request: LocalEvent, store: LabsStore): void {
        store.LabActions.GetLabsActionsCount();
        store.LabActions.RefreshActions(store.LabsActionInboxModel.get("CurrentInbox"), store.LabsActionInboxModel.get("GlobalActionSearchText"), store.LabsActionInboxModel.get("SortColumn"), store.LabsActionInboxModel.get("SortColumnDirection"));
    }

    public SetColumnSort(request: LocalEvent, store: LabsStore): void {
        var tableTarget = request.Get<MyleTableTarget>("target");

        if (tableTarget === MyleTableTarget.Myle_LabActionsInbox_Search_ColumnSortClick) {
            var columnOrderType = request.Get<LabActionInboxSortOrderType>("sortColumn");

            if (store.LabsActionInboxModel.get("SortColumn") === columnOrderType) {
                // Same Column, Change Direction
                if (store.LabsActionInboxModel.get("SortColumnDirection") === SortDirection.ASC)
                    store.LabsActionInboxModel = store.LabsActionInboxModel.set("SortColumnDirection", SortDirection.DESC);
                else
                    store.LabsActionInboxModel = store.LabsActionInboxModel.set("SortColumnDirection", SortDirection.ASC);
            }
            else {
                store.LabsActionInboxModel = store.LabsActionInboxModel.set("SortColumn", columnOrderType);
                store.LabsActionInboxModel = store.LabsActionInboxModel.set("SortColumnDirection", SortDirection.DESC);
            }

            var column = request.Get<MyleTableColumn>("columnObject");

            if (column) {
                if (column.columnOptions.IsSortActive) {
                    column.ToggleSortDirection();
                }
                column.columnOptions.IsSortActive = true;
            }

            store.LabActions.RefreshActions(store.LabsActionInboxModel.get("CurrentInbox"), store.LabsActionInboxModel.get("GlobalActionSearchText"), store.LabsActionInboxModel.get("SortColumn"), store.LabsActionInboxModel.get("SortColumnDirection"));
        }
    }
}

export { LabsActionsInboxViewHandler };
